'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import { Container } from '@/components/Container';
import { FullArticle } from '@/components/FullArticle/FullArticle';
import { AdditionalPaddings } from '@/components/Layouts/AdditionalPadding';
import { BlogLayout } from '@/components/Layouts/BlogLayout';
import { FeaturesLayout } from '@/components/Layouts/FeaturesLayout';
import Section from '@/components/Section/Section';
import { ArticlesList } from '@/features/ArticlesList/ArticlesList';
import { Banner } from '@/features/Banner/Banner';
import { BookDemo } from '@/features/BookDemo/BookDemo';
import { ExploreTools } from '@/features/ExploreTools/ExploreTools';
import { FAQ } from '@/features/FAQ/FAQ';
import { FeaturesIntro } from '@/features/FeaturesIntro/FeaturesIntro';
import { Testimonals } from '@/features/Testimonals/Testimonals';
// import { WorkFlowV2 } from '@/features/WorkFlow/WorkFlowV2';
import {
  articles,
  blog,
  bookDemo,
  explore,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
} from '@/lib/features/sales_proposal';

const BlogDynamic = dynamic(() => import('@/features/Blog/Blog'), {
  ssr: false,
});

const SalesProposal = () => {
  return (
    <>
      <FeaturesIntro {...intro} />

      {/* <WorkFlowV2 /> */}

      <Section>
        <Container>
          <FullArticle revert={true} item={fullArticle2} />
        </Container>
      </Section>

      <Container>
        <Section title={articles.title}>
          <ArticlesList {...articles} />
        </Section>
      </Container>

      <Section>
        <AdditionalPaddings>
          <Banner
            title={`Our sales proposal automation software streamlines proposal creation, delivering personalized, professional proposals that drive results`}
            secondaryTitle=""
            subTitle="Close More Deals with Ease!"
            listItems={[]}
          />
        </AdditionalPaddings>
      </Section>

      <Section>
        <Container>
          <FullArticle revert={false} item={fullArticle1} />
        </Container>
      </Section>

      <Section>
        <Container>
          <ExploreTools {...explore} />
        </Container>
      </Section>

      <FeaturesLayout>
        <Section>
          <Banner
            title={`Take the first step towards more effective sales engagements. Click below and start creating proposals that turn prospects into partners`}
            subTitle="Ready to Elevate Your Sales Proposals?"
            secondaryTitle=""
            listItems={[]}
          />
        </Section>

        <Section>
          <Container>
            <Testimonals {...testimonals} />
          </Container>
        </Section>

        <Container>
          <Section title={faq.title}>
            <FAQ {...faq} />
          </Section>
        </Container>
      </FeaturesLayout>

      <BlogLayout>
        <Container>
          <Section title={blog.title} description={blog.description}>
            <BlogDynamic />
          </Section>
        </Container>
      </BlogLayout>

      <BookDemo {...bookDemo} />
    </>
  );
};

export default SalesProposal;
